import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type {
  BaseConnectionData,
  OktaConfigData,
} from './EnterpriseConnectionSchema';
import {
  ClientCredentialsFields,
  DomainField,
  LoginExperienceSection,
} from './SharedSsoFormFields';

interface Props {
  disabled?: boolean;
}

const OktaConfigurationForm: FC<Props> = ({ disabled = false }) => {
  const { control } = useFormContext<OktaConfigData>();
  const baseControl = control as unknown as Control<BaseConnectionData>;
  const { t } = useTranslation('common', { keyPrefix: 'sso' });

  return (
    <>
      <DomainField
        control={baseControl}
        isDisabled={disabled}
        label={t('domain.okta.label')}
        description={t('domain.okta.description')}
        placeholder={t('domain.okta.placeholder')}
      />

      <ClientCredentialsFields
        control={baseControl}
        isDisabled={disabled}
        providerLabel={'Okta'}
      />

      <LoginExperienceSection control={baseControl} isDisabled={disabled} />
    </>
  );
};

export default OktaConfigurationForm;
